import tw, { styled } from 'twin.macro';
import { navigate } from 'gatsby';
import React from 'react';
import { GraphQLClient, gql } from 'graphql-request';

import config from '../../utils/config';
import SocialIcons from '../global/SocialIcons';
import ContactForm from './ContactForm';

const client = new GraphQLClient(config.apiUrl, {
  timeout: 60000,
});

const contactUsMutation = gql`
  mutation contact($input: ContactInput) {
    contact(input: $input) {
      status
      message
    }
  }
`;
const IconsContainer = styled.div(() => [tw`bg-white px-4 py-10`]);

const ContactFormBlock = () => {
  const handleSubmit = async (formData) => {
    const variables = { input: formData };
    await client
      .request(contactUsMutation, variables)
      .then((data) => {
        setTimeout(() => {
          if (data) {
            navigate('/thank-you/');
          }
        }, 1000);
      })
      .catch((error) => {
        console.log('error', error);
      });
  };

  return (
    <section tw="bg-slate py-10">
      <div className="container">
        <div tw="container mx-auto items-center bg-slate">
          <div tw="md:flex w-full text-center md:text-left p-4 items-center">
            <div tw="block md:flex w-full text-center md:text-left p-4 items-center">
              <IconsContainer tw="hidden md:block">
                <SocialIcons variant="secondary" />
              </IconsContainer>
              <IconsContainer tw="md:hidden">
                <SocialIcons flex />
              </IconsContainer>
              <div tw="w-full md:w-2/3  pb-8 md:pb-0">
                <ContactForm onSubmit={(val) => handleSubmit(val)} />
              </div>
              <div style={{ height: '350px', width: '100%' }}>
                <iframe
                  title="Our address"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2430.0818424726604!2d-1.2411419844853033!3d52.47765384711942!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48776a0d103a0563%3A0x8f3a0386f033202f!2sPalmers%20at%20Ullesthorpe!5e0!3m2!1sen!2sus!4v1652341261094!5m2!1sen!2sus"
                  width="100%"
                  height="350"
                  allowFullScreen=""
                  loading="lazy"
                  referrerpolicy="no-referrer-when-downgrade"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactFormBlock;
